import { isSupportedPageType } from 'admin-panel/constants/page-types';

import type ItemModel from 'admin-panel/models/item';
import type PageModel from 'admin-panel/models/page';

export function canHoldItems(page: PageModel) {
  return Boolean(page.id) && isSupportedPageType(page.cleanType);
}

export function canOpenItems(page: PageModel) {
  return canHoldItems(page) && page.itemsCount > 0;
}

export function isItemOnPage(item: ItemModel, page: PageModel) {
  return (
    (Boolean(page.id) && item.hasMany('pages').ids().includes(page.id)) ||
    (Boolean(item.id) && page.hasMany('items').ids().includes(item.id))
  );
}
